import { createContext } from 'react';

export const FilterOptions = createContext();
